// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__f1x3K","toggler":"Switch_toggler__RtUKw","disabled":"Switch_disabled__kmheu","on":"Switch_on__EpOuY"};